'use strict';

/* Views */
import DocumentEdit from './edit/document-edit.component';
import DocumentList from './list/document-list.component';
import DocumentUpload from './upload/document-upload.component';

/* Services */
import DocumentService from '../../services/document/document.service';

export default angular.module('conduuApp.documents', [DocumentUpload, DocumentEdit, DocumentList, DocumentService])
  .name;



// WEBPACK FOOTER //
// ./client/app/document/index.js